<template>
  <b-skeleton-wrapper :loading="loading">
    <template #loading>
      <div
        v-for="(item, index) in [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]"
        :key="index"
        class="menu__item"
        :class="{ 'menu__item--minimized': minimized }"
      >
        <div
          class="menu__item__right-box"
          :class="{ 'width-percent-100': !minimized }"
        >
          <div class="menu__item__right-box__icon-box">
            <b-skeleton
              class="parvandeh__icon-box margin-bottom-0"
              :width="minimized ? '100%' : '15%'"
            ></b-skeleton>
          </div>
          <div
            v-show="!minimized"
            class="menu__item__right-box__title width-percent-100"
          >
            <b-skeleton
              v-if="!minimized"
              class="parvandeh__name margin-bottom-0"
              width="85%"
            ></b-skeleton>
          </div>
        </div>
      </div>
    </template>
    <slot name="default"></slot>
  </b-skeleton-wrapper>
</template>

<script>
export default {
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    minimized: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
